/**
 * Company: SPHMedia
 * Description: [Starting layout for myBH]
 */
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { ReactElement } from "react";

import {
  STARTING_DESKTOP_LAYOUT,
  STARTING_TABLET_LEFT,
  STARTING_TABLET_RIGHT,
} from "./helper/layout";
import { renderSlot } from "./helper/renderSlot";

export type MyBHStartingLayoutProps = {
  articles: ProcessedArticleData[];
};

/**
 * MyBHStartingLayout
 * Description: [Starting layout for myBH "For You" page shows only 5 articles]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MyBHStartingLayout({
  articles,
}: MyBHStartingLayoutProps): ReactElement {
  if (articles.length === 0) {
    return <div>No articles available.</div>;
  }

  return (
    <WidgetWrapper>
      {/* Desktop */}
      <div
        className="hidden lg:block max-w-[1183px]"
        data-testid="desktop-layout"
      >
        <div className="grid grid-cols-4 grid-rows-2 gap-5">
          {STARTING_DESKTOP_LAYOUT.map((slot) =>
            renderSlot(
              {
                imgWidth: 281,
                imgHeight: 192.94,
                ...slot,
              },
              articles,
              "startingLayoutDesktop",
            ),
          )}
        </div>
      </div>

      {/* Tablet */}
      <div className="hidden md:block lg:hidden" data-testid="tablet-layout">
        <div className="grid grid-cols-[2fr_1fr] gap-5">
          {/* Left */}
          <div className="flex flex-col gap-5">
            {STARTING_TABLET_LEFT.map((slot) =>
              renderSlot(
                { imgWidth: 453, imgHeight: 311, ...slot },
                articles,
                "startingLayoutTabLeft",
              ),
            )}
          </div>

          {/* Right */}
          <div className="flex flex-col gap-5">
            {STARTING_TABLET_RIGHT.map((slot) =>
              renderSlot(
                { imgWidth: 263, imgHeight: 180.58, ...slot },
                articles,
                "startingLayoutTabRight",
              ),
            )}
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="flex md:hidden" data-testid="mobile-layout">
        <div className="flex flex-col gap-7">
          {articles
            .slice(0, 5)
            .map((_, i) =>
              renderSlot({ index: i }, articles, "startingLayoutMobile"),
            )}
        </div>
      </div>
    </WidgetWrapper>
  );
}
